import React from 'react';

function TermsOfService({ onBack }) {
  return (
    <div className="legal-page">
      <div className="legal-header">
        <button onClick={onBack} className="legal-back-btn">← Back to Home</button>
        <h1>Terms of Service</h1>
        <p className="legal-effective-date">Last updated: June 16, 2026</p>
      </div>

      <div className="legal-content">
        <section className="legal-section">
          <h2>1. Acceptance of Terms</h2>
          <p>
            By accessing or using StoryMeal ("the Website"), you agree to be bound by these Terms of 
            Service ("Terms"). If you do not agree to all of these Terms, please do not use the Website.
          </p>
          <p>
            We reserve the right to update or modify these Terms at any time. Changes will be effective 
            immediately upon posting. Your continued use of the Website after any changes constitutes 
            your acceptance of the new Terms.
          </p>
        </section>

        <section className="legal-section">
          <h2>2. Description of Service</h2>
          <p>
            StoryMeal is a platform that allows users to read, write, and share stories across various 
            genres. The Website provides the following services:
          </p>
          <ul>
            <li>Browse and read stories submitted by users</li>
            <li>Write and publish your own stories</li>
            <li>Like and comment on stories</li>
            <li>Create a user profile via Google OAuth authentication</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>3. User Registration and Accounts</h2>
          <p>
            To access certain features of the Website, you may be required to create an account. When 
            you create an account, you agree to:
          </p>
          <ul>
            <li>Provide accurate, current, and complete information</li>
            <li>Maintain and update your account information as needed</li>
            <li>Keep your account credentials secure and confidential</li>
            <li>Notify us immediately of any unauthorized use of your account</li>
          </ul>
          <p>
            You are responsible for all activities that occur under your account. We reserve the right 
            to suspend or terminate accounts that violate these Terms.
          </p>
        </section>

        <section className="legal-section">
          <h2>4. User-Generated Content</h2>
          <h3>Ownership</h3>
          <p>
            You retain all ownership rights to the stories and content you submit to StoryMeal. By 
            submitting content, you grant us a non-exclusive, royalty-free, worldwide license to 
            display, distribute, and promote your content on the Website.
          </p>

          <h3>Content Guidelines</h3>
          <p>You agree not to submit content that:</p>
          <ul>
            <li>Is unlawful, harmful, threatening, abusive, harassing, or defamatory</li>
            <li>Infringes on the intellectual property rights of others</li>
            <li>Contains hateful or discriminatory material</li>
            <li>Contains explicit or gratuitous violence</li>
            <li>Contains spam or commercial solicitation</li>
            <li>Impersonates any person or entity</li>
          </ul>

          <h3>Moderation</h3>
          <p>
            We reserve the right to review, edit, or remove any user-generated content at our sole 
            discretion and without prior notice.
          </p>
        </section>

        <section className="legal-section">
          <h2>5. Intellectual Property</h2>
          <p>
            The Website and its original content, features, and functionality (excluding user-generated 
            content) are owned by StoryMeal and are protected by international copyright, trademark, 
            and other intellectual property laws.
          </p>
          <p>
            You may not reproduce, distribute, modify, create derivative works from, or exploit any 
            part of the Website without our prior written consent.
          </p>
        </section>

        <section className="legal-section">
          <h2>6. Third-Party Links and Advertisements</h2>
          <p>
            Our Website may contain links to third-party websites and services, including 
            advertisements served by Google AdSense. We do not control and are not responsible for 
            the content, privacy policies, or practices of any third-party websites.
          </p>
          <p>
            Google AdSense may serve advertisements based on your interests and browsing history. 
            Google's use of advertising cookies is governed by Google's own privacy policy.
          </p>
        </section>

        <section className="legal-section">
          <h2>7. Prohibited Activities</h2>
          <p>You agree not to engage in any of the following prohibited activities:</p>
          <ul>
            <li>Using the Website for any unlawful purpose</li>
            <li>Attempting to gain unauthorized access to our systems</li>
            <li>Interfering with or disrupting the Website's functionality</li>
            <li>Uploading viruses or malicious code</li>
            <li>Using automated bots or scrapers without our permission</li>
            <li>Engaging in any activity that could harm or overburden our infrastructure</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>8. Limitation of Liability</h2>
          <p>
            To the maximum extent permitted by law, StoryMeal and its affiliates shall not be liable 
            for any indirect, incidental, special, consequential, or punitive damages arising out of 
            or related to your use of the Website.
          </p>
          <p>
            This includes, but is not limited to, damages for loss of profits, data, or other 
            intangible losses, even if we have been advised of the possibility of such damages.
          </p>
        </section>

        <section className="legal-section">
          <h2>9. Disclaimer of Warranties</h2>
          <p>
            The Website is provided on an "as is" and "as available" basis without any warranties of 
            any kind, either express or implied. We do not warrant that:
          </p>
          <ul>
            <li>The Website will be uninterrupted or error-free</li>
            <li>The results obtained from using the Website will be accurate or reliable</li>
            <li>The quality of any content obtained through the Website will meet your expectations</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>10. Termination</h2>
          <p>
            We may terminate or suspend your account and access to the Website at any time, without 
            prior notice, for conduct that we believe violates these Terms or is harmful to other 
            users, us, or third parties.
          </p>
          <p>
            Upon termination, your right to use the Website will immediately cease. Any content you 
            have submitted may remain on the Website at our discretion.
          </p>
        </section>

        <section className="legal-section">
          <h2>11. Governing Law</h2>
          <p>
            These Terms shall be governed by and construed in accordance with the laws of the 
            applicable jurisdiction. Any disputes arising under these Terms shall be resolved in the 
            courts of that jurisdiction.
          </p>
        </section>

        <section className="legal-section">
          <h2>12. Changes to Terms</h2>
          <p>
            We reserve the right to modify or replace these Terms at any time. Material changes will 
            be effective 30 days after posting. Your continued use of the Website after any changes 
            become effective constitutes your acceptance of the new Terms.
          </p>
        </section>

        <section className="legal-section">
          <h2>13. Contact Information</h2>
          <p>
            If you have any questions about these Terms, please contact us at:
          </p>
          <p><strong>Email:</strong> <a href="mailto:helpdesk@austrasoft.com">helpdesk@austrasoft.com</a></p>
          <p>
            <strong>Website:</strong>{' '}
            <a href="https://austrasoft.com" target="_blank" rel="noopener noreferrer">Austrasoft.com</a>
          </p>
        </section>
      </div>
    </div>
  );
}

export default TermsOfService;